import { type FC, type ReactElement, useEffect } from "react";

import { useCountdown } from "@ch/helpers/hooks/useCountdown";

export interface CountdownChildrenProps {
  currentCountdown: number;
  isComplete: boolean;
  restart: (newDuration?: number) => void;
  start: (newDuration?: number) => void;
  stop: () => void;
}

interface CountdownProps {
  duration: number;
  callbackOnComplete?: () => void;
  shouldStop?: boolean;
  children: (params: CountdownChildrenProps) => ReactElement;
  shouldStartOnMount?: boolean;
}

const Countdown: FC<CountdownProps> = (props) => {
  const {
    duration,
    shouldStop,
    callbackOnComplete,
    children,
    shouldStartOnMount = true,
  } = props;
  const {
    countdown: currentCountdown,
    isComplete,
    restart,
    stop,
    start,
  } = useCountdown({
    duration,
  });

  useEffect(() => {
    if (shouldStartOnMount) {
      start();
    } else {
      stop();
    }
  }, [start, shouldStartOnMount, stop]);

  useEffect(() => {
    if (isComplete) {
      callbackOnComplete?.();
    }
  }, [callbackOnComplete, isComplete]);

  useEffect(() => {
    if (shouldStop) {
      stop();
    }
  }, [shouldStop, stop]);

  return children({ currentCountdown, isComplete, restart, start, stop });
};

export { Countdown };
